export default __webpack_public_path__ + "static/media/01_Go-for-a-swim.927ad6b3.jpg";